import { BigNumber } from '@xylabs/bignumber'
import { EthAddress } from '@xylabs/sdk-js'

import { Quadkey } from '../Quadkey'
import { XyoWorldGeotokensWrapper } from './Geotokens'

class XyoWorldGeotokenWrapper {
  public static geotokenWrappers = new Map<string, XyoWorldGeotokenWrapper>()

  public geotokens: XyoWorldGeotokensWrapper

  public quadkey: Quadkey

  private constructor(quadkey: Quadkey, geotokens: XyoWorldGeotokensWrapper) {
    this.quadkey = quadkey
    this.geotokens = geotokens
  }

  public static get(geotokens: XyoWorldGeotokensWrapper, quadkey: Quadkey) {
    const result = XyoWorldGeotokenWrapper.geotokenWrappers.get(quadkey.toBase4HashLabel()) ?? new XyoWorldGeotokenWrapper(quadkey, geotokens)
    XyoWorldGeotokenWrapper.geotokenWrappers.set(quadkey.toBase4HashLabel(), result)
    return result
  }

  public async depositErc20(erc20Address: EthAddress, amount: BigNumber) {
    return await this.geotokens.erc20Deposit(this.quadkey, erc20Address, amount)
  }

  public async getErc20Balance(erc20Address: EthAddress) {
    return await this.geotokens.erc20Balance(this.quadkey, erc20Address)
  }

  public async withdrawErc20(erc20Address: EthAddress, amount: BigNumber) {
    return await this.geotokens.erc20Withdraw(this.quadkey, erc20Address, amount)
  }
}

export { XyoWorldGeotokenWrapper }
